import React, { useEffect, useState } from 'react';
import PrimeReact, { PrimeReactProvider } from 'primereact/api';
import { Button } from 'primereact/button';

const ThemeSwitcher = (props) => {
  // const [theme, setTheme] = useState('light');

  const changeTheme = () => {
    const newTheme = window.theme === 'dark' ? 'light' : 'dark';
    PrimeReact?.changeTheme?.(`lara-${window.theme}-teal`, `lara-${newTheme}-teal`, 'app-theme', () =>
      window.theme = newTheme
    );
  };

  return (
    <Button
      className="border-round-sm px-0 py-0"
      icon="pi pi-sun"
      size="small"
      onClick={changeTheme}
      style={{
        width: 28,
        height: 28
      }}
    />
  );
};
  
export default ThemeSwitcher;
